export const FREE_STUDY_TIME_OPTIONS = [
  { value: 'over_three_hours', label: '3時間以上' },
  { value: 'one_to_three_hours', label: '1〜3時間' },
  { value: 'thirty_to_sixty_minutes', label: '30分〜1時間' },
  { value: 'almost_none', label: 'ほぼなし' },
  { value: 'none', label: 'なし' },
];

export const FREE_STUDY_TIME_LABELS = FREE_STUDY_TIME_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

export const BUSYNESS_LABELS = {
  1: '非常に余裕がある',
  2: 'やや余裕がある',
  3: '普通',
  4: '忙しい',
  5: '非常に忙しい',
};

function parseTimeToMinutes(value) {
  if (!value || typeof value !== 'string') {
    return null;
  }

  const match = /^(\d{2}):(\d{2})$/.exec(value.trim());
  if (!match) {
    return null;
  }

  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return null;
  }

  return (hours * 60) + minutes;
}

function scoreStartTime(minutes) {
  if (minutes >= (9 * 60)) return 1;
  if (minutes >= (8 * 60) + 30) return 2;
  if (minutes >= (8 * 60)) return 3;
  if (minutes >= (7 * 60) + 30) return 4;
  return 5;
}

function scoreEndTime(minutes) {
  if (minutes <= (16 * 60)) return 1;
  if (minutes <= (17 * 60)) return 2;
  if (minutes <= (18 * 60)) return 3;
  if (minutes <= (19 * 60)) return 4;
  return 5;
}

function scoreDuration(durationMinutes) {
  if (durationMinutes <= (6 * 60) + 30) return 1;
  if (durationMinutes <= (8 * 60)) return 2;
  if (durationMinutes <= (9 * 60) + 30) return 3;
  if (durationMinutes <= (11 * 60)) return 4;
  return 5;
}

function scoreLateDaysPerWeek(lateDaysPerWeek) {
  if (lateDaysPerWeek <= 0) return 1;
  if (lateDaysPerWeek === 1) return 2;
  if (lateDaysPerWeek <= 3) return 3;
  if (lateDaysPerWeek <= 5) return 4;
  return 5;
}

const freeStudyScores = {
  over_three_hours: 1,
  one_to_three_hours: 2,
  thirty_to_sixty_minutes: 3,
  almost_none: 4,
  none: 5,
};

export function calculateBusyness({
  typical_start_time,
  typical_end_time,
  late_days_per_week,
  free_study_time,
  has_night_duty,
}) {
  const startMinutes = parseTimeToMinutes(typical_start_time);
  const endMinutes = parseTimeToMinutes(typical_end_time);
  const lateDays = Number(late_days_per_week);

  if (
    startMinutes === null
    || endMinutes === null
    || Number.isNaN(lateDays)
    || !Object.prototype.hasOwnProperty.call(freeStudyScores, free_study_time)
  ) {
    return null;
  }

  const durationMinutes = Math.max(0, endMinutes - startMinutes);
  const startScore = scoreStartTime(startMinutes);
  const endScore = scoreEndTime(endMinutes);
  const durationScore = scoreDuration(durationMinutes);
  const lateScore = scoreLateDaysPerWeek(lateDays);
  const freeStudyScore = freeStudyScores[free_study_time];

  if (
    startMinutes <= (7 * 60)
    || endMinutes >= (19 * 60) + 30
    || durationMinutes >= (12 * 60)
    || lateDays >= 5
    || (free_study_time === 'none' && has_night_duty)
  ) {
    return 5;
  }

  if (
    startMinutes >= (9 * 60)
    && endMinutes <= (16 * 60)
    && durationMinutes <= (6 * 60) + 30
    && lateDays === 0
    && free_study_time === 'over_three_hours'
    && !has_night_duty
  ) {
    return 1;
  }

  let baseScore = Math.round(
    (
      (startScore * 1)
      + (endScore * 2)
      + (durationScore * 2)
      + (lateScore * 2)
      + (freeStudyScore * 2)
    ) / 9,
  );

  if (
    endMinutes >= (18 * 60) + 30
    || durationMinutes >= (10 * 60) + 30
    || lateDays >= 4
    || free_study_time === 'none'
    || free_study_time === 'almost_none'
  ) {
    baseScore = Math.max(baseScore, 4);
  }

  if (has_night_duty) {
    baseScore = Math.min(5, Math.max(4, baseScore + 1));
  }

  return Math.max(1, Math.min(baseScore, 5));
}
